/** Icons & inspiration thumbnails for Kids Boy — 4-12 years (`public/assets/kids/boy/4 -12 kid/`) */
const KIDS_BOY_412_BASE = `${process.env.PUBLIC_URL || ''}/assets/kids/boy/4 -12 kid`;

function kidsBoy412Asset(filename) {
  return `${KIDS_BOY_412_BASE}/${filename}`;
}

export const KIDS_BOY_412_CATEGORY_PREVIEW = kidsBoy412Asset('Kurta.png');

export const KIDS_BOY_412_ICON_BY_VALUE = {
  kurta: kidsBoy412Asset('Kurta.png'),
  shirt: kidsBoy412Asset('Shirt.png'),
  tshirt: kidsBoy412Asset('T shirt.png'),
  trouser: kidsBoy412Asset('Trouser .png'),
  trousers: kidsBoy412Asset('Trouser .png'),
  blazer: kidsBoy412Asset('Blezer.png'),
  jacket: kidsBoy412Asset('Nehru jacket.png'),
  'nehru jacket': kidsBoy412Asset('Nehru jacket.png'),
  hoodies: kidsBoy412Asset('Hoodie.png'),
  layering: kidsBoy412Asset('Hoodie.png'),
  sweater: kidsBoy412Asset('Hoodie.png'),
  'kurta-dhoti': kidsBoy412Asset('dhoti.png'),
  pajama: kidsBoy412Asset('Payjama.png'),
  cordset: kidsBoy412Asset('cordset.png'),
  socks: `${process.env.PUBLIC_URL || ''}/assets/Mens wear/socks.png`,
};

export function kidsBoyUses412Assets(kidAgeRange) {
  // Kids boy 4–12 uses the same garment thumbnails as teens (12–18) — men's wear icons.
  return false;
}

export function getKidsBoy412GarmentIcon(typeValue) {
  if (!typeValue) return null;
  return KIDS_BOY_412_ICON_BY_VALUE[typeValue] || null;
}
